import React, { useContext } from 'react';
import {
  ArrowDownSmIcon,
  ArrowUpSmIcon,
  DeleteIcon,
  IconButton,
} from '@paypalcorp/pp-react';
import { Field, change, getFormValues } from 'redux-form';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import BasicInputField from '../../shared/fields/BasicInputField';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';

const ProgramFieldV3 = ({
  position,
  showUpArrow,
  showDownArrow,
  showDelete,
  programNames,
  dispatch,
}) => {
  const worldReady = useContext(WorldReadyContext);

  const renderTextField = (props) => {
    return <BasicInputField {...props} />;
  };

  const onChangeProgram = (value) => {
    programNames[position] = value?.trim();
    const newProgramNames = [...programNames];
    change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames);
  };

  const moveProgramUp = () => {
    const newProgramNames = [...programNames];
    const tempProgram = newProgramNames[position];

    newProgramNames[position] = newProgramNames[position - 1];
    newProgramNames[position - 1] = tempProgram;

    dispatch(change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames));

    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position].join(''),
        newProgramNames[position]
      )
    );
    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position - 1].join(''),
        newProgramNames[position - 1]
      )
    );
  };

  const moveProgramDown = () => {
    const newProgramNames = [...programNames];
    const tempProgram = newProgramNames[position];

    newProgramNames[position] = newProgramNames[position + 1];
    newProgramNames[position + 1] = tempProgram;

    dispatch(change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames));

    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position].join(''),
        newProgramNames[position]
      )
    );
    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position + 1].join(''),
        newProgramNames[position + 1]
      )
    );
  };

  const removeProgram = () => {
    const newProgramNames = [];
    for (let i = 0; i < programNames.length; i++) {
      if (i !== position) {
        newProgramNames.push(programNames[i]);
      }
      if (i === programNames.length - 1) {
        dispatch(change(BTN_FACTORY_V3_FORM, ['programInput', i].join(''), ''));
      }
    }

    for (let i = 0; i < newProgramNames.length; i++) {
      dispatch(
        change(
          BTN_FACTORY_V3_FORM,
          ['programInput', i].join(''),
          newProgramNames[i]
        )
      );
    }

    dispatch(change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames));
  };

  return (
    <div className="program-row">
      <Field
        name={`programInput${position}`}
        id={`programInput${position}`}
        label={
          position === 0
            ? new MessageFormat(worldReady, {
                id: 'buttonsV3.programs.programNameDefaultField',
              }).format({
                value: position + 1,
              })
            : new MessageFormat(worldReady, {
                id: 'buttonsV3.programs.programName',
              }).format({
                value: position + 1,
              })
        }
        className="program-input"
        onChange={(e) => onChangeProgram(e.target.value)}
        onBlur={(e) => onChangeProgram(e.target.value)}
        component={renderTextField}
      />
      <div className={`program-buttons ${!showDelete ? 'display-none' : ''}`}>
        <IconButton
          buttonType="tertiary"
          svgIconComponent={ArrowUpSmIcon}
          id={`UpArrow${position}`}
          onClick={moveProgramUp}
          className={`${!showUpArrow ? 'hide-icon' : ''}`}
        >
          <Message id="buttonsV3.programs.upArrow" />
        </IconButton>
        <IconButton
          buttonType="tertiary"
          svgIconComponent={ArrowDownSmIcon}
          id={`DownArrow${position}`}
          onClick={moveProgramDown}
          className={`${!showDownArrow ? 'hide-icon' : ''}`}
        >
          <Message id="buttonsV3.programs.downArrow" />
        </IconButton>
        <IconButton
          buttonType="tertiary"
          svgIconComponent={DeleteIcon}
          id={`removeProgram${position}`}
          onClick={removeProgram}
          className={`${!showDelete ? 'hide-icon' : ''} icon-trash`}
        >
          <Message id="buttonsV3.programs.removeButton" />
        </IconButton>
      </div>
    </div>
  );
};

ProgramFieldV3.propTypes = {
  position: PropTypes.number,
  showUpArrow: PropTypes.bool,
  showDownArrow: PropTypes.bool,
  showDelete: PropTypes.bool,
  programNames: PropTypes.array,
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
  const formValues = getFormValues(BTN_FACTORY_V3_FORM)(state) || {};

  return {
    programNames: formValues.programNames,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgramFieldV3);
